<div class="xxx">
    <div class="abs-center wd-xl">
        <!-- START panel-->
        <div class="text-center mb-xl">
            <div class="text-lg mb-lg">Vous avez terminé votre saisie</div>
            <p>Vous allez recevoir un email de confirmation avec un récapitulatif de vos réinscriptions.</p>
        </div>
    </div>
</div>